import { Configuration } from "@azure/msal-browser";

const adminRedirectUri =
  process.env.REACT_APP_AZURE_REDIRECT_URI ||
  `${window.location.origin}/verified-kyc-users`;

/**
 * MSAL configuration for the admin verified-KYC page.
 * Mirrors apac-partner-pims-web-interface/src/config/msal-config.tsx.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "",
    authority: process.env.REACT_APP_AZURE_AUTHORITY || "",
    redirectUri: adminRedirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [process.env.REACT_APP_AZURE_API_SCOPE || "User.Read"],
};

export default msalConfig;
